export const FieldSettingType = {
    DISABLED: "isDisable",
    ISTEXT: "isText",
    MULTISELECT: "isMultiSelect",
    ISPRIMARYBUTTONVISIBLE: "isPrimaryButtonVisible",
    ISINFOBUTTONVISIBLE: "isInfoButtonVisible",
    CKEDITORDISABLED: "CKEditorDisabled",
    ISMULTIPLE: "isMultiple",
    ISFILENAMECLEARED: "isFileNameCleared",
    ISTEMPLATEBTNDISABLE: "isTemplateBtnDisable",
    ISLABELICONVISIBLE: "isLabelIconVisible",
    ISLOADING: "isLoading",
    ISMASKED: "isMasked"
}